import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import {
  DeviceHeatingCircuitIdCommands,
  Feature,
  FeatureNames,
  IsEnabledProperty,
  IsNumberValueProperty,
} from '@vi-iot/client';

import { GatewayDevice, GatewayStore, InstallationFeaturesStore } from '@store';

@Component({
  selector: 'app-src-devices',
  templateUrl: './src-devices.component.html',
  styleUrls: ['./src-devices.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SrcDevicesComponent implements OnInit {
  circuits$: Observable<Feature<IsEnabledProperty, never>>;
  heatingCircuitId$: {
    [deviceId: string]: Observable<Feature<IsNumberValueProperty, DeviceHeatingCircuitIdCommands>>;
  } = {};

  @Input() deviceGroup: {
    id?: string;
    modelId?: string;
    type?: string;
    devices?: GatewayDevice[];
  } = {};

  constructor(
    public gatewayStore: GatewayStore,
    private installationFeaturesStore: InstallationFeaturesStore
  ) {}

  ngOnInit(): void {
    this.circuits$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.circuits
    );
    if (this.deviceGroup?.devices?.length) {
      this.deviceGroup.devices.forEach((device) => {
        if (device.id) {
          this.heatingCircuitId$[
            device.id
          ] = this.installationFeaturesStore.selectInstallationDeviceFeature(
            FeatureNames.deviceHeatingCircuitId,
            device.id
          );
        }
      });
    }
  }
}
